export const SET_IS_TEST_RIDE_IFRAME = 'SET_IS_TEST_RIDE_IFRAME';
export const SET_DEALER_ID_TEST_RIDE = 'SET_DEALER_ID_TEST_RIDE';
export const SET_TEST_RIDE_CATEGORY_ID = 'SET_TEST_RIDE_CATEGORY_ID';
